<p>BENEFITS</p>
<div
    class="custom-view-home-page grid grid-gap-15 grid-col-xs-100 grid-col-xxs-100 grid-col-lt-100 grid-col-sm-100 grid-col-hd-100">
    <div [ngClass]="{'fullHeight': !message}">
        <app-static-message-page></app-static-message-page>
    </div>
    <div>
        <app-dynamic-message-page [message]="message"></app-dynamic-message-page>
    </div>
</div>